import { makeStyles } from '@material-ui/core/styles'

const borderStyle = 'solid 1px #AEAFC7'

export const useStyles = makeStyles({
  modalText: {
    textAlign: 'center',
  },
  error: {
    color: '#FF0000',
  },
  boardBorder: {
    '& #head': {
      border: borderStyle,
      borderTop: 'none',
    },
    '& #head:last-child:not(:only-child)': {
      borderLeft: 'none',
    },
    '& #column': {
      borderRight: borderStyle,
      borderTop: borderStyle,
    },
    '& #column:last-child': {
      borderRight: 'none',
    },
    '& #columnHeader': {
      borderBottom: borderStyle,
    },
  },
  boardOverlay: ({ isXScrolled }) => ({
    position: 'absolute',
    height: '100%',
    width: '20%',
    maxWidth: 108,
    right: 0,
    top: 0,
    zIndex: 9,
    backgroundImage: 'linear-gradient(to right, transparent, white)',
    opacity: isXScrolled ? 0 : 1,
    transition: 'opacity .5s ease-out',
    pointerEvents: 'none',
  }),
})
